import TemplateRegistry from '../template/template-registry';
import * as log from 'loglevel';

class CountryController {

    constructor(onChange, getOption) {
        this.onChange = onChange;
        this.getOption = getOption;
        this.config = null; // reference updated on each render
        this.option = null; // reference updated on each render

        // This array contains all ISO 3166-1 alpha-2 country codes
        this.codes = [
            'AC', 'AD', 'AE', 'AF', 'AG', 'AI', 'AL', 'AM', 'AO', 'AQ', 'AR', 'AS',
            'AT', 'AU', 'AW', 'AX', 'AZ', 'BA', 'BB', 'BD', 'BE', 'BF', 'BG', 'BH',
            'BI', 'BJ', 'BL', 'BM', 'BN', 'BO', 'BQ', 'BR', 'BS', 'BT', 'BV', 'BW',
            'BY', 'BZ', 'CA', 'CC', 'CD', 'CF', 'CG', 'CH', 'CI', 'CK', 'CL', 'CM',
            'CN', 'CO', 'CR', 'CU', 'CV', 'CW', 'CX', 'CY', 'CZ', 'DE', 'DG', 'DJ',
            'DK', 'DM', 'DO', 'DZ', 'EA', 'EC', 'EE', 'EG', 'EH', 'ER', 'ES', 'ET',
            'FI', 'FJ', 'FK', 'FM', 'FO', 'FR', 'GA', 'GB', 'GD', 'GE', 'GF', 'GG',
            'GH', 'GI', 'GL', 'GM', 'GN', 'GP', 'GQ', 'GR', 'GS', 'GT', 'GU', 'GW',
            'GY', 'HK', 'HM', 'HN', 'HR', 'HT', 'HU', 'IC', 'ID', 'IE', 'IL', 'IM',
            'IN', 'IO', 'IQ', 'IR', 'IS', 'IT', 'JE', 'JM', 'JO', 'JP', 'KE', 'KG',
            'KH', 'KI', 'KM', 'KN', 'KP', 'KR', 'KW', 'KY', 'KZ', 'LA', 'LB', 'LC',
            'LI', 'LK', 'LR', 'LS', 'LT', 'LU', 'LV', 'LY', 'MA', 'MC', 'MD', 'ME',
            'MF', 'MG', 'MH', 'MK', 'ML', 'MM', 'MN', 'MO', 'MP', 'MQ', 'MR', 'MS',
            'MT', 'MU', 'MV', 'MW', 'MX', 'MY', 'MZ', 'NA', 'NC', 'NE', 'NF', 'NG',
            'NI', 'NL', 'NO', 'NP', 'NR', 'NU', 'NZ', 'OM', 'PA', 'PE', 'PF', 'PG',
            'PH', 'PK', 'PL', 'PM', 'PN', 'PR', 'PS', 'PT', 'PW', 'PY', 'QA', 'RE',
            'RO', 'RS', 'RU', 'RW', 'SA', 'SB', 'SC', 'SD', 'SE', 'SG', 'SH', 'SI',
            'SJ', 'SK', 'SL', 'SM', 'SN', 'SO', 'SR', 'SS', 'ST', 'SV', 'SX', 'SY',
            'SZ', 'TA', 'TC', 'TD', 'TF', 'TG', 'TH', 'TJ', 'TK', 'TL', 'TM', 'TN',
            'TO', 'TR', 'TT', 'TV', 'TW', 'TZ', 'UA', 'UG', 'UM', 'US', 'UY', 'UZ',
            'VA', 'VC', 'VE', 'VG', 'VI', 'VN', 'VU', 'WF', 'WS', 'XK', 'YE', 'YT',
            'ZA', 'ZM', 'ZW'
        ];

        this.regionNames = new Intl.DisplayNames([navigator.language], { type: 'region' });
    }

    init(option) {

        let countryCodes = this.codes; // all countries

        // limited countries
        if(option.params.countryCodes){
            if(Array.isArray(option.params.countryCodes)) {
                countryCodes = option.params.countryCodes;
            } else if(typeof option.params.countryCodes === 'string'){
                countryCodes = option.params.countryCodes.split(',');
            }
        }

        // generate values
        option.values = countryCodes.map((code) => {
            try {
                return {
                    value: code, // fixed code
                    text: this.regionNames.of(code) // lookup name in browser language
                };
            } catch (error) {
                log.warn('country code not found:', code);
                return null;
            }
        }).filter(country => country !== null);

        // sort alphabetically by .text
        option.values.sort((a, b) => a.text.localeCompare(b.text));

        // auto select country based on shopify global variable
        if(window.Shopify?.country){
            // check if country is in list
            let optionValue = option.values.find(optionValue => optionValue.value === window.Shopify.country);
            if(optionValue){
                option.value = optionValue.value;
            }
        }

    }
}

// B2B Forms: country select
TemplateRegistry.templates['country'] = (option, config, onChange) => {

    let init = option._controller === undefined;

    // get or create country controller
    option._controller = option._controller || new CountryController(onChange);

    // option reference can change (mainly in editor mode) so we just always update it to the current reference
    option._controller.option = option;
    // config is always a new object - storing reference on controller init would keep the old instance
    option._controller.config = config;

    // INFO: editor mode always update the values (required to init the discount attributes on the values)
    if(init || config.editorMode){
        option._controller.init(option);
    }

    return TemplateRegistry.templates['select'](option, config, onChange);
};